import {Swiper} from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

function swipers() {
	// Initialize all swiper containers that aren't already initialized
	document.querySelectorAll('.swiper-container:not(.swiper-initialized):not(.wiper-image-gallery)').forEach(container => {
		const swiperName = container.classList[1].replace('swiper-', '');
		const slidesPerView = container.getAttribute("data-slides") || 1;
		const autoHeight = container.getAttribute("data-autoheight") || false;
		const slidesPerViewMobile = container.getAttribute("data-slides-mobile") || 1;

		new Swiper(container, {
			modules: [Pagination, Navigation, Autoplay],
			slidesPerView: slidesPerViewMobile,
			spaceBetween: 24,
			autoHeight: autoHeight,
			navigation: {
				nextEl: `.swiper-button-next-${swiperName}`,
				prevEl: `.swiper-button-prev-${swiperName}`,
			},

            pagination: {
                el: `.swiper-pagination-${swiperName}`,
                clickable: true,
            },

			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// },

			breakpoints: {
				1024: {
					slidesPerView: (slidesPerView - 1),
				},
				1280: {
					slidesPerView
				},
			},
		});
	});
}

export default swipers;